import * as React from "react";
import PropTypes from "prop-types";
import "./Style.css";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import decisionMakerImage from "../../../../Assets/Cloudfigma.svg";
import ContactDetailList from "../../../../Components/AiLeads/ContactDetailList/ContactDetailList";
import RightSidebar from "../../../../Components/RightSiderbar/RightSiderbar";
import axios from "axios";
import Loader from "../../../../Components/Loader/Loader";
import { toast } from "react-toastify";
import { Modal } from "@mui/material";
import Box from "@mui/material/Box";
import { ClearIcon } from "@mui/x-date-pickers";
import {
  APIUrlOne,
  APIUrlThree,
  APIUrlToken,
  APIUrlTwo,
  GetOktaAuthData,
  GetUserId,
  logEvent,
} from "../../../../Utils/Utils";
import { useLocation, useNavigate } from "react-router-dom";
import IndustryDropdown from "../../../../Components/AiLeads/IndustrySectorDropdown/Index";
import InfiniteScroll from "react-infinite-scroll-component";
import stargray from "../../../../Assets/Stargrey.png";
import starRed from "../../../../Assets/starRed.svg";
import * as XLSX from "xlsx";
import ProspectRequestModal from "../../../../Components/RequestUpdateModals/ProspectRequestModal";
import MessageModal from "../../../../Components/MessageModal/MessageModal";
import crieboxes from "../../../../Assets/crieboxs.svg";
import crieboxestwo from "../../../../Assets/crieboxesbtntwo.svg";
import linkedin from "../../../../Assets/linkedin.svg";
import visitLinkImage from "../../../../Assets/visit-link.svg";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import phone from "../../../../Assets/phone.svg";
import sortingimg from "../../../../Assets/sortingarrow.svg";
import SouthIcon from "@mui/icons-material/South";
import NorthIcon from "@mui/icons-material/North";
import OrgDetailsFav from "../../../../Components/FavoritesList/AddToFavoriteModal/OrgDetailsFav";
import SalesForceMessageModal from "../../../../Components/MessageModal/SalesForceMessageModal";
import PeopleDetailsFav from "../../../../Components/FavoritesList/AddToFavoriteModal/PeopleDetailsFav";
import activeSaleforceLogo from "../../../../Assets/activeSaleforceLogo.svg";
import { Card, CardContent, Grid, Typography } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import RightSidebarMobile from "../../../../Components/RightSiderbar/RightSidebarMobile";
let loaded = false;
function Row({
  row,
  selected,
  onSelect,
  setRowsSelect,
  selectedOuterRows,
  favoritesList,
  setFavoritesList,
  listFavoriteRecords,
  handleRowSelect,
  showCrieBoxes,
  value,
  setValue,
  setCrieNavigate,
  // handleRemoveFavouriteProspect,
  aiDecisionMakerTableCompany,
  isTabletLandscape,
}) {
  const [open, setOpen] = React.useState(false);
  const loggedInUserId = GetUserId();
  const navigate = useNavigate();
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [dataShortestPath, setDataShortestPath] = React.useState();
  const [directConnection, setDirectConnection] = React.useState();
  const handleRightsidebar = (event) => {
    logEvent("shortest-path", "JOI");
    const data = {};
    data.source_uid = Number(loggedInUserId);
    data.target_uid = Number(event);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      data: data,
      url: `${APIUrlTwo()}/v1/shortest-path`,
    };
    axios(option)
      .then((response) => {
        if (response?.status === 200) {
          // const shortestPath = { ...response.data };
          // shortestPath.source = loggedInUserId;
          // shortestPath.target = event;
          const data = Object.values(response.data);
          setDataShortestPath(data);
          setOpenSidebar(true);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  const handleFavouriteLead = (row) => {
    // const data = {
    //   "people_id": row.person_id
    // }
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      data: [row.person_id],
      url: `${APIUrlThree()}/favorites/people/list/add-record?user_id=${loggedInUserId}`,
    };
    axios(option)
      .then(async (response) => {
        // toast.success("Prospect added to favorites")
        aiDecisionMakerTableCompany(true);
      })
      .catch(() => {});
  };

  // const handleSearchCrie = () => {
  //   const data = {}
  //   // setLoading(true);
  //   const option = {
  //     method: "POST",
  //     headers: {
  //       "access-control-allow-origin": "*",
  //       "content-type": "application/json",
  //       "X-API-Key": APIUrlToken()
  //     },
  //     data: data,
  //     url: `${APIUrlThree()}/v1/get_crie?src_org_id=${process.env.REACT_APP_JOI_JO_ID}&dest_org_id=${row?.org_id}`,
  //   };
  //   axios(option)
  //     .then((e) => {
  //       // setLoading(false);
  //       if (e?.status === 200) {
  //         let data = e?.data
  //         setDirectConnection(data)
  //       }
  //     })
  //     .catch(() => {
  //       // setLoading(false);
  //     });
  // }
  // React.useEffect(() => {
  //   handleSearchCrie();
  // }, [])

  return (
    <>
      {showCrieBoxes ? (
        <TableRow>
          <TableCell className="">
            <div
              className="first_crie_box-cards"
              // To navigate to crie paths
              //  onClick={() => {
              //             setValue(1);
              //             setCrieNavigate(row?.person_id)
              //           }}
            >
              <div className="inner-card-criesale">
                <div
                  onClick={() =>
                    row?.id && navigate(`/Profile/${row?.person_id}`)
                  }
                  className={
                    row?.decision_maker === true
                      ? "Decision-maker-user-name-cards"
                      : "Decision-maker-user-namenoborder-cards"
                  }
                >
                  <img
                    className={
                      row?.suspect_status === null
                        ? "hide-image"
                        : "decisionMakerImage-new-cards"
                    }
                    // src={decisionMakerImage}
                    src={
                      row?.journey_status === "project created"
                        ? activeSaleforceLogo
                        : decisionMakerImage
                    }
                    alt=""
                  />
                  <p className="letter-heading">
                    {row?.first_name?.substring(0, 1)}
                    {row?.last_name?.substring(0, 1)}
                  </p>
                </div>
                <div className="crie_info-cards">
                  <div className="crie_name-cards">
                    <p
                      className="crie_name-cards-names"
                      onClick={() =>
                        row?.id && navigate(`/Profile/${row?.person_id}`)
                      }
                    >
                      {" "}
                      {row?.first_name} {row?.last_name}
                    </p>{" "}
                    <p>{row?.strengthData?.strength}</p>
                  </div>
                  <div style={{ cursor: "pointer" }}>
                    {row?.primary_job_title}
                  </div>
                  <div style={{ cursor: "pointer" }}>
                    {row?.primary_organization}
                  </div>
                  <a
                    className="company-profile-mention-linkedin"
                    target="_blank"
                    // rel="noopener noreferrer"
                    href={row?.email ? `mailto:${row.email}` : undefined}
                    style={{
                      textDecoration: row?.email ? "underline" : "none",
                      cursor: row?.email ? "pointer" : "default",
                    }}
                  >
                    <EmailOutlinedIcon
                      style={{
                        color: "#003057",
                        width: "15px",
                        height: "15px",
                      }}
                    />
                    {row?.email
                      ? row.email.split(",")[0].length > 18
                        ? row.email.split(",")[0].substring(0, 18) + "..."
                        : row.email.split(",")[0]
                      : "--"}
                  </a>
                  <a className="company-profile-mention">
                    <img
                      src={phone}
                      alt=""
                      style={{ width: "13px", height: "13px" }}
                    />
                    {row?.phone_no || "--"}
                  </a>
                  <p className="company-profile-mention-2">
                    <span>
                      <img
                        src={linkedin}
                        alt=""
                        style={{ width: "14px", height: "14px" }}
                      />
                      <a
                        className="company-profile-mention-linkedin"
                        href={row?.linkedin}
                        target="_blank"
                      >
                        {row?.linkedin
                          ? row?.linkedin.split(
                              "https://www.linkedin.com/in/",
                            )[1]?.length > 18
                            ? row?.linkedin
                                .split("https://www.linkedin.com/")[1]
                                .substring(0, 18) + "..."
                            : row?.linkedin.split(
                                "https://www.linkedin.com/",
                              )[1]
                          : "--"}
                      </a>
                    </span>
                    {/* {row?.linkedin && (
                      <a href={row?.linkedin} target="_blank" className="crie-a-end">
                        <img src={visitLinkImage} alt="" style={{ width: "14px", height: "14px" }} />
                      </a>
                    )} */}
                  </p>
                  <div className="d-connections-card">
                    <p className="connections-num">
                      {row?.direct_connection_count
                        ? row?.direct_connection_count
                        : 0}
                    </p>

                    <p
                      onClick={() => {
                        setValue(1);
                        setCrieNavigate(row?.person_id);
                      }}
                    >
                      Direct Connections
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </TableCell>
        </TableRow>
      ) : (
        <TableRow className="juyds" sx={{ "& > *": { borderBottom: "unset" } }}>
          <>
            <TableCell className="checkbox-row-table-inner checkbox-row-table">
              <div className="kjhgf">
                <input
                  type="checkbox"
                  onChange={() => handleRowSelect(row)}
                  checked={selectedOuterRows?.some(
                    (item) => item.person_id === row?.person_id,
                  )}
                />
              </div>
            </TableCell>
            {/* <TableCell component="th" scope="row">
              <>
                {row?.isFavourite ? (
                  <div
                    className="kjhgf"
                    onClick={() => handleRemoveFavouriteProspect(row)}
                  >
                    <img src={starRed} alt="" />
                  </div>
                ) : (
                  <div
                    className="kjhgf"
                    onClick={() => handleFavouriteLead(row)}
                  >
                    <img src={stargray} alt="" />
                  </div>
                )}
              </>
            </TableCell> */}

            <TableCell className="Decisions-row-empty" align="left">
              <div className="Decision-maker-user-name-main-container">
                <div
                  className={
                    row?.decision_maker === true
                      ? "Decision-maker-user-name"
                      : "Decision-maker-user-namenoborder"
                  }
                >
                  <img
                    className={
                      row?.suspect_status === null
                        ? "hide-image"
                        : "decisionMakerImage-new"
                    }
                    // src={decisionMakerImage}
                    src={
                      row?.journey_status === "project created"
                        ? activeSaleforceLogo
                        : decisionMakerImage
                    }
                    alt=""
                  />
                  <p className="letter-heading">
                    {row?.first_name?.substring(0, 1)}
                    {row?.last_name?.substring(0, 1)}
                  </p>
                </div>
                {/* <div className="name-and-title-text">
              <h3 className="company-name-country-prospect">
                {`${row?.first_name} ${row?.last_name}`}
              </h3>
              <p className="after-company-name-country-prospect">
                {row?.primary_job_title?.substring(0, 15) +
                  (row?.primary_job_title?.length > 10 ? "...." : "")}
              </p>
            </div> */}
              </div>
            </TableCell>
            <TableCell
              className="Decision-maker-userTeblesell"
              align="left"
              onClick={() => {
                navigate(
                  `/Profile/${row?.person_id == 0 ? "0" : row?.person_id}`,
                );
              }}
              style={{ cursor: "pointer" }}
            >
              {/* <img
            className={
              row?.suspect_status === null ? "hide-image" : "decisionMakerImage"
            }
            src={decisionMakerImage}
            alt=""
          /> */}
              <div className="Decision-maker-user-name-main-container">
                {/* <div
              className={
                row?.decision_maker === true
                  ? "Decision-maker-user-name"
                  : "Decision-maker-user-namenoborder"
              }
            >
              <p className="letter-heading">
                {row?.first_name?.substring(0, 1)}
                {row?.last_name?.substring(0, 1)}
              </p>
            </div> */}
                {/* <div className="name-and-title-text">
              <h3 className="company-name-country-prospect-added">
                {`${row?.first_name} ${row?.last_name}`}
              </h3>
              <p className="after-company-name-country-prospect-new">
                {row?.primary_job_title?.substring(0, 15) +
                  (row?.primary_job_title?.length > 10 ? "...." : "")}
              </p>
            </div> */}

                <div className="name-and-title-text">
                  <h3 className="company-name-country-prospect-added">
                    {`${
                      row?.first_name === "jp" ? "JP" : row?.first_name || "-"
                    } ${row?.last_name}`}
                  </h3>
                  {/* <p className="after-company-name-country-prospect-new">
                {row?.primary_job_title
                  ? row.primary_job_title.substring(0, 20) +
                  (row.primary_job_title.length > 10 ? "..." : "")
                  : '-'
                }
              </p> */}
                  <div className="job-title-container">
                    <div className="tooltip-container-jobtitle">
                      <p
                        className={
                          row?.raw_job_title
                            ? "tooltip-highlights-jobtitle"
                            : "tooltip-highlights-jobtitle-none"
                        }
                      >
                        {row?.raw_job_title}
                      </p>
                      <p className="after-company-name-country-prospect-new">
                        {row?.primary_job_title
                          ? row.primary_job_title.substring(0, 20) +
                            (row.primary_job_title.length > 20 ? "..." : "")
                          : "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </TableCell>
            <TableCell component="th" scope="row">
              <p className="strengthdata">
                {row?.strengthData?.strength
                  ? row?.strengthData?.strength
                  : "-"}
              </p>
            </TableCell>
            {/* <TableCell align="left">
          <h3 className="annual-revenue-table">{row.primary_organization}</h3>
        </TableCell> */}

            <TableCell
              align="left"
              className="table-cell-of-contact-details-dropdown-th"
            >
              <div
                className="Set-dropdown-ofIndustry"
                style={{ position: "relative" }}
              >
                <div className="email-andrelative-other-info">
                  <div className="maked-component-of-dropdown-forai-leads">
                    <IndustryDropdown row={row} />
                  </div>
                </div>
              </div>
            </TableCell>

            {/* <TableCell align="left">
                    <h3 className="industry-sector-table">-</h3>
                </TableCell> */}
            {isTabletLandscape ? (
              ""
            ) : (
              <TableCell align="left">
                <div className="Suspect-table-data">
                  <h3 className="industry-sector-table">
                    {row?.suspect_status ? row.suspect_status : "-"}
                  </h3>
                </div>
              </TableCell>
            )}
            {/* <TableCell
          align="left"
          className="contact-details-leads-to-company-profile"
        >
          <div style={{ position: "relative" }}>
            <div className="email-and-other-info">
              <div className="maked-component-of-dropdown">
                <ContactDetailList item={row} />
              </div>
            </div>
          </div>
        </TableCell> */}
            <TableCell
              align="left"
              className="table-cell-of-contact-details-dropdown-th-prospect"
            >
              <div
                className="Set-dropdown-ofContactDetailList"
                style={{ position: "relative" }}
              >
                <div className="email-and-other-infodc">
                  <div className="maked-component-of-dropdown">
                    <ContactDetailList item={row} />
                  </div>
                </div>
              </div>
            </TableCell>
          </>
          <TableCell className="table-cellhandleRightsidebar-newclasss">
            <div className="table-cellhandleRightsidebar-edit">
              {/* <Tooltip   className="dfvbvfe2wefvfe2wefvwfv" title={"View AI Path"}> */}
              <IconButton
                aria-label="expand row"
                size="small"
                // onClick={() => handleRightsidebar(row?.person_id)}
                className="button-collapse-table-for-company"
              >
                <RightSidebar
                  row={row}
                  rowid={row?.person_id}
                  handleRightsidebar={handleRightsidebar}
                  dataShortestPath={dataShortestPath}
                  openSidebar={openSidebar}
                />
              </IconButton>
              {/* </Tooltip> */}
            </div>
          </TableCell>
        </TableRow>
      )}
    </>
  );
}

Row.propTypes = {
  row: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
};
export default function EmployeesTable({
  informationData,
  selectedOuterRows,
  setSelectedOuterRows,
  tableCommingData,
  setTableCommingData,
  istableDataFilter,
  setCurrentLeadsLength,
  dataForInformation,
  setIsSalesForceTrigger,
  isSalesForceTrigger,
  rowData,
  setIsDecisionMakerExcel,
  isDecisionMakerExcel,
  archiveRecord,
  setArchiveRecord,
  trackRecord,
  setTrackRecord,
  addToFavorite,
  setAddToFavorite,
  setDisableRequestUpdate,
  requestUpdateRecord,
  setRequestUpdateRecord,
  setLeadsRequestModal,
  setShowSalesForce,
  setValue,
  setCrieNavigate,
  handleTrackingdata,
  listFavoriteleads,
  setFavoritesLeads,
  favoritesLeads,
  informationDataModal,
  isPortrait,
  isMobile,
}) {
  const userInfo = GetOktaAuthData();
  const loggedUser = userInfo?.user?.profile;
  const exportToExcel = (data, filename) => {
    const filteredData = data.map(
      ({ person_id, org_id, strengthData, ...rest }) => rest,
    );
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${filename}.xlsx`);
    setIsDecisionMakerExcel(false);
  };

  const location = useLocation();
  const isComponyScreen = location?.state?.isComponyScreen;
  const [previousState, setPreviousState] = React.useState(false);
  React.useEffect(() => {
    if (isComponyScreen) {
      setPreviousState(true);
    }
  }, [isComponyScreen]);

  const [loading, setLoading] = React.useState(false);
  const [decisionMakerData, setDecisionMakerData] = React.useState([]);
  const [decisionMakerDataCompany, setDecisionMakerDataCompany] =
    React.useState([]);

  const [selectedRows, setSelectedRows] = React.useState([]);
  const [strengthTableData, setStrengthTableData] = React.useState([]);
  const [openCreateListmdl, setOpenCreateListmdl] = React.useState(false);
  const loggedInUserId = GetUserId();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "8px",
  };
  const [successModel, setSuccessModel] = React.useState("");
  const decisionMakerTableData = decisionMakerData;
  const [hasMore, setHasMore] = React.useState(false);
  const [page, setPage] = React.useState(1);
  const [skip, setSkip] = React.useState(0);
  const [isMakerTable, setIsMakerTable] = React.useState(false);
  const [decisionMakerDataCount, setDecisionMakerDataCount] =
    React.useState("");
  const [rowsSelect, setRowsSelect] = React.useState({});
  const [rowsSelectAll, setRowsSelectAll] = React.useState(false);
  // const [selectedOuterRows, setSelectedOuterRows] = React.useState([])
  const [favoritesList, setFavoritesList] = React.useState([]);
  const [archivesList, setArchivesList] = React.useState([]);
  const [requestUpdateModal, setRequestUpdateModal] = React.useState(false);
  const [messageModal, setMessageModal] = React.useState(false);
  const [messageModalTrack, setMessageModalTrack] = React.useState(false);
  const [messageModalSalesforce, setMessageModalSalesforce] =
    React.useState(false);
  const [showCrieBoxes, setShowCrieBoxes] = React.useState(false);

  const [data, setData] = React.useState([]);

  const [sortField, setSortField] = React.useState("");
  const [sortOrder, setSortOrder] = React.useState(null);

  const handleCrieBoxes = () => {
    setShowCrieBoxes(true);
  };
  const handleCrieBoxesClose = () => {
    setShowCrieBoxes(false);
  };
  const getStrength = async () => {
    if (!decisionMakerTableData?.length && !decisionMakerDataCompany?.length)
      return;
    setLoading(true);
    const tuples = decisionMakerDataCompany?.length
      ? decisionMakerDataCompany.map((item) => ({
          items: [loggedInUserId?.toString(), item?.person_id?.toString()],
        }))
      : decisionMakerTableData.map((item) => ({
          items: [loggedInUserId?.toString(), item?.person_id?.toString()],
        }));
    const data = { tuples };
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      data: data,
      url: `${APIUrlTwo()}/v1/conn_strength`,
    };
    try {
      const response = await axios(options);
      const strengthData = response?.data;
      let updatedData = [];
      if (decisionMakerDataCompany?.length) {
        updatedData = decisionMakerDataCompany?.map((item, index) => ({
          ...item,
          strengthData: strengthData[index],
        }));
      } else {
        updatedData = decisionMakerTableData?.map((item, index) => ({
          ...item,
          strengthData: strengthData[index],
        }));
      }

      setStrengthTableData(updatedData);
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  React.useEffect(() => {
    getStrength();
  }, [decisionMakerTableData, decisionMakerDataCompany]);
  // const fetchMoreData = () => {
  //     const newSkip = skip + 50;
  //     setSkip(newSkip);
  //     aiDecisionMakerTable(newSkip);
  // };
  const fetchMoreData = () => {
    if (!decisionMakerData?.length && !decisionMakerDataCompany?.length) return;
    const hasMore =
      decisionMakerDataCompany?.length?.length < rowData?.people_count ||
      decisionMakerData?.length < rowData?.people_count ||
      decisionMakerDataCount;
    if (!hasMore) return;
    setSkip((prevskip) => prevskip + 50);
    // const newSkip = skip + 10;
    // aiDecisionMakerTable(newSkip);
  };
  React.useEffect(() => {
    setSkip(0);
    setDecisionMakerData([]);
    setDecisionMakerDataCompany([]);
  }, [dataForInformation]);
  // React.useEffect(() => {
  //   if (orgId !== (newdata?.org_id || newdata.id || isComponyScreen)) {
  //     setSkip(0);
  //     setDecisionMakerData([])
  //   }

  // }, [newdata?.org_id, newdata.id,isComponyScreen])
  const aiDecisionMakerTableCompany = (eventName) => {
    setHasMore(false);
    setLoading(true);
    // if (orgId !== (newdata?.org_id || newdata.id) && isComponyScreen) {
    //   setOrgId(newdata?.org_id || newdata.id)
    // }

    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/decision_maker?org_id=${rowData}&limit=50&skip=${
        eventName ? 0 : skip
      }`,
    };
    axios(option)
      .then((e) => {
        setDecisionMakerDataCount(e?.data?.count);
        setLoading(false);
        const comingData = e?.data?.data;

        if (comingData.length === 0) {
          setHasMore(false);
          setDecisionMakerDataCompany([]);
          setStrengthTableData([]);
        } else {
          if (comingData.length % 50 === 0)
            setTimeout(() => setHasMore(true), 1000);
          decisionMakerDataCompany.length === 0 || eventName
            ? setDecisionMakerDataCompany(comingData)
            : setDecisionMakerDataCompany([
                ...decisionMakerDataCompany,
                ...comingData,
              ]);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const aiDecisionMakerTable = (eventName) => {
    setHasMore(false);
    setLoading(true);
    // if (orgId !== (newdata?.org_id || newdata.id) && isComponyScreen) {
    //   setOrgId(newdata?.org_id || newdata.id)
    // }

    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/decision_maker?org_id=${rowData}&limit=50&skip=${skip}`,
    };
    axios(option)
      .then((e) => {
        setDecisionMakerDataCount(e?.data?.count);
        setLoading(false);
        const comingData = e?.data?.data;

        if (comingData.length === 0) {
          setHasMore(false);
          setDecisionMakerData([]);
          setStrengthTableData([]);
        } else {
          if (comingData.length % 50 === 0)
            setTimeout(() => setHasMore(true), 1000);
          decisionMakerData.length === 0
            ? setDecisionMakerData(comingData)
            : setDecisionMakerData([...decisionMakerData, ...comingData]);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  React.useEffect(() => {
    if (dataForInformation) {
      if (previousState) {
        aiDecisionMakerTableCompany();
      } else {
        aiDecisionMakerTable();
      }
    }
  }, [dataForInformation]);
  // React.useEffect(() => {
  //   if (dataForInformation) {
  //     setComingOrgId(dataForInformation?.org_id);
  //   }
  // }, [dataForInformation]);
  React.useEffect(() => {
    if (tableCommingData) {
      setCurrentLeadsLength(tableCommingData?.length);
    }
  }, [tableCommingData]);

  React.useEffect(() => {
    if (decisionMakerDataCompany?.length >= 50) {
      aiDecisionMakerTableCompany();
    } else if (decisionMakerData?.length >= 50) {
      aiDecisionMakerTable();
    }
  }, [skip]);

  React.useEffect(() => {
    if (isDecisionMakerExcel) {
      exportToExcel(
        decisionMakerDataCompany || decisionMakerData,
        "decisionmaker_exported_data",
      );
    }
  }, [isDecisionMakerExcel]);

  const handleRowSelect = (row) => {
    setSelectedOuterRows((prevSelectedRows) => {
      const isAlreadySelected = prevSelectedRows.some(
        (item) => item.person_id === row.person_id,
      );

      if (isAlreadySelected) {
        return prevSelectedRows.filter(
          (item) => item.person_id !== row.person_id,
        );
      } else {
        return [...prevSelectedRows, row];
      }
    });
  };
  React.useEffect(() => {
    if (rowsSelectAll) {
      const allRows = [...strengthTableData];
      setSelectedOuterRows(allRows);
    } else if (rowsSelectAll === false) {
      setSelectedOuterRows([]);
    } else if (selectedOuterRows?.length == strengthTableData?.length) {
      setRowsSelectAll(true);
    } else if (selectedOuterRows?.length < strengthTableData?.length) {
      setRowsSelectAll(false);
    }
  }, [rowsSelectAll, rowsSelect]);

  React.useEffect(() => {
    if (archiveRecord == true) {
      setMessageModal(true);
      setArchiveRecord(false);
      // handleArchiveRecords()
    }
  }, [archiveRecord]);
  const listFavoriteRecords = async () => {
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/list_favourite_prospects?userid=${Number(
        GetUserId(),
      )}&limit=200&offset=0`,
    };
    try {
      const response = await axios(options);
      setFavoritesList(response?.data?.data);
      // setArchiveRecord(false)
      // toast.success("Prospects Archived Successfully")
    } catch (error) {
      // setLoading(false);
      toast.error(error?.response?.data?.message);
    } finally {
      // setLoading(false);
    }
  };

  const listArchiveRecords = async () => {
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/list_user_archive_prospects?userid=${Number(
        GetUserId(),
      )}&limit=200&offset=0`,
    };
    try {
      const response = await axios(options);
      const data = response?.data?.data?.filter(
        (item) => item?.org_id !== null,
      );
      setArchivesList(data);
    } catch (error) {
      // setLoading(false);
      toast.error(error?.response?.data?.message);
    } finally {
      // setLoading(false);
    }
  };
  React.useEffect(() => {
    // listFavoriteRecords();
    listArchiveRecords();
    listFavoriteleads();
  }, []);

  const handleRemoveFavLead = () => {
    const data = favoritesLeads?.find(
      (item) => item?.org_id === Number(rowData),
    );
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/remove_favourite_leads?id=${
        data?.favourites_id
      }`,
    };
    axios(option)
      .then(async (response) => {
        setLoading(false);
        informationData();
      })
      .catch(() => {
        setLoading(false);
      });
  };
  // const handleRemoveFavouriteProspect = (row, show) => {
  //   const option = {
  //     method: "DELETE",
  //     headers: {
  //       "access-control-allow-origin": "*",
  //       "content-type": "application/json",
  //       "X-API-Key": APIUrlToken()
  //     },
  //     url: `${APIUrlThree()}/favorites/delete_favorites_people?user_id=${GetUserId()}`,
  //     data: [row.person_id],
  //   };
  //   axios(option)
  //     .then(async (response) => {
  //       setLoading(false);
  //       aiDecisionMakerTableCompany(true)
  //       toast.success("Prospect removed from favorites")
  //     })
  //     .catch(() => {
  //       setLoading(false);
  //     });
  // }
  const handleArchiveRecords = async () => {
    if (!selectedOuterRows?.length) {
      if (favoritesLeads?.some((item) => item?.org_id === Number(rowData))) {
        handleRemoveFavLead();
      }
      const data = [
        {
          user_id: Number(GetUserId()),
          org_id: rowData,
        },
      ];
      const options = {
        method: "POST",
        headers: {
          "access-control-allow-origin": "*",
          "content-type": "application/json",
          "X-API-Key": APIUrlToken(),
        },
        data: data,
        url: `${APIUrlThree()}/v1/send_archive`,
      };
      try {
        const response = await axios(options);
        if (response?.data?.message === "Already archived") {
          toast.success("Organization already Archived.");
        } else {
          toast.success("Organization Archived Successfully");
        }
        listFavoriteleads();
        setArchiveRecord(false);
        setMessageModal(false);
        setSelectedOuterRows([]);
      } catch (error) {
        toast.error(error?.response?.data?.message);
      } finally {
      }
    } else {
      // await Promise.all(selectedOuterRows.map(i => handleRemoveFavouriteProspect(i, true)));
      const data = selectedOuterRows.map((item) => ({
        user_id: Number(GetUserId()),
        people_id: item?.person_id,
      }));

      const options = {
        method: "POST",
        headers: {
          "access-control-allow-origin": "*",
          "content-type": "application/json",
          "X-API-Key": APIUrlToken(),
        },
        data: data,
        url: `${APIUrlThree()}/v1/send_archive`,
      };
      try {
        const response = await axios(options);
        // handleRemoveFavLead()
        setArchiveRecord(false);
        setMessageModal(false);
        if (response?.data?.message === "Already archived") {
          toast.success("Prospects already Archived.");
        } else {
          toast.success("Prospects Archived Successfully");
        }
        setSelectedOuterRows([]);
        listArchiveRecords();
        listFavoriteRecords();
      } catch (error) {
        // setLoading(false);
        toast.error(error?.response?.data?.message);
      } finally {
        // setLoading(false);
      }
    }
  };
  React.useEffect(() => {
    if (trackRecord == true) {
      // handleTrackRecords()
      setMessageModalTrack(true);
      setTrackRecord(false);
    }
  }, [trackRecord]);

  React.useEffect(() => {
    if (addToFavorite == true) {
      setOpenCreateListmdl(true);
      setAddToFavorite(false);
    }
  }, [addToFavorite]);

  const handleTrackRecords = () => {
    if (!selectedOuterRows?.length) {
      setLoading(true);
      const data = [rowData];
      const option = {
        method: "POST",
        headers: {
          "access-control-allow-origin": "*",
          "X-API-Key": APIUrlToken(),
        },
        data: data,
        url: `${APIUrlThree()}/v1/save_tracking_organization?user_id=${Number(
          GetUserId(),
        )}`,
      };
      axios(option)
        .then((response) => {
          if (response.status === 200) {
            setLoading(false);
            setTrackRecord(false);
            setMessageModalTrack(false);
            handleTrackingdata();
            toast.success("Organization Tracking Added");
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response.data.message);
        });
    } else {
      setLoading(true);
      const data = selectedOuterRows.map((item) => item?.person_id);
      const option = {
        method: "POST",
        headers: {
          "access-control-allow-origin": "*",
          "X-API-Key": APIUrlToken(),
        },
        data: data,
        url: `${APIUrlThree()}/v1/save_tracking_prospect?user_id=${Number(
          GetUserId(),
        )}`,
      };
      axios(option)
        .then((response) => {
          if (response.status === 200) {
            setLoading(false);
            setTrackRecord(false);
            setMessageModalTrack(false);
            toast.success("Prospects Tracking Added");
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response.data.message);
        });
    }
  };

  React.useEffect(() => {
    if (selectedOuterRows?.length < 1 && requestUpdateRecord == true) {
      setDisableRequestUpdate(false);
      setLeadsRequestModal(true);
    } else if (selectedOuterRows?.length === 1 && requestUpdateRecord == true) {
      setRequestUpdateModal(true);
      setRequestUpdateRecord(false);
      setDisableRequestUpdate(false);
    } else if (selectedOuterRows?.length > 1 && requestUpdateRecord == true) {
      setDisableRequestUpdate(false);
      setRequestUpdateRecord(false);
      toast.error("Please select only one record to request update");
    } else {
      setDisableRequestUpdate(false);
    }
  }, [selectedOuterRows, requestUpdateRecord]);

  const validateSalesforce = () => {
    if (!selectedOuterRows || selectedOuterRows?.length === 0) {
      toast.error("Please Select Records For Push To Salesforce");
      setIsSalesForceTrigger(false);
      return false;
    }
    return true;
  };
  const pushToSalesForce = () => {
    logEvent("push_to_salesforce", "JOI");
    // if (!validateSalesforce()) return;
    setLoading(true);

    const ms = {
      updateData: {
        data: selectedOuterRows?.map((item) => ({
          items: [item?.person_id, "Suspect"],
        })),
      },
    };
    const transformedData = selectedOuterRows
      ?.map((i) => {
        const organizationInfo =
          decisionMakerData.find((org) => org?.org_id === i?.org_id) || {};
        return { ...i, organizationInfo };
      })
      ?.map((item) => ({
        attributes: {
          type: "Lead",
          referenceId: "rec" + item?.person_id,
        },
        LastName: item?.last_name,
        FirstName: item?.first_name,
        Salutation: null,
        Email: item?.email,
        Phone: item?.phone_no,
        Title: item?.primary_job_title,
        Company: item?.primary_organization,
        City: item?.organizationInfo?.location_identifiers?.split(",")[0],
        State: item?.organizationInfo?.location_identifiers?.split(",")[1],
        Country: item?.organizationInfo?.country,
        LeadSource: "JOI",
        Status: "Suspect",
        LinkedIn_Profile__c: item?.linkedin,
        Suspect_Source_Detail__c: `${loggedUser?.firstName} ${loggedUser?.lastName}`,
      }));
    const finalJson = { records: transformedData, ...ms };
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      data: finalJson,
      url: `${APIUrlOne()}/v1/add_suspects`,
    };
    axios(option)
      .then(async (response) => {
        setLoading(false);
        if (response?.status === 200) {
          toast.success("Record has been created");
          // const promiseRequest = selectedRows?.map((item) => {
          //   return ExpandHandler(item?.org_id, 1);
          // });
          // const result = await Promise.all(promiseRequest);
          // setExpandHandlerAccept(...result);
          setSelectedOuterRows([]);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  React.useEffect(() => {
    if (isSalesForceTrigger) {
      if (!validateSalesforce()) return;
      setMessageModalSalesforce(true);
      setIsSalesForceTrigger(false);
      // pushToSalesForce();
    }
  }, [isSalesForceTrigger]);
  React.useEffect(() => {
    if (selectedOuterRows?.length) {
      const data = selectedOuterRows?.filter(
        (item) => item.suspect_status !== null,
      );
      if (data?.length) {
        setShowSalesForce("disable");
      } else {
        setShowSalesForce("show");
      }
    } else {
      setShowSalesForce(false);
    }
  }, [selectedOuterRows]);

  React.useEffect(() => {
    setData(strengthTableData);
  }, [strengthTableData]);

  React.useEffect(() => {
    const sortedDataDefault = strengthTableData
      ?.filter(
        (item) => !archivesList?.some((i) => i?.person_id === item?.person_id),
      )
      ?.sort((a, b) => {
        if (a.decision_maker && !b.decision_maker) return -1;
        if (!a.decision_maker && b.decision_maker) return 1;
        return (
          (b.strengthData?.strength || 0) - (a.strengthData?.strength || 0)
        );
      });
    setData(sortedDataDefault);
  }, [strengthTableData, archivesList]);

  const handleSort = (field) => {
    let newSortOrder;
    if (sortField === field) {
      newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    } else {
      newSortOrder = "asc";
    }
    setSortOrder(newSortOrder);
    setSortField(field);

    const sortedData = [...data].sort((a, b) => {
      let aValue = field.includes(".")
        ? field.split(".").reduce((acc, key) => acc?.[key], a)
        : a[field];
      let bValue = field.includes(".")
        ? field.split(".").reduce((acc, key) => acc?.[key], b)
        : b[field];

      // Handling empty values (null, "", "-") by assigning them a high sorting weight
      const isEmpty = (val) => val === null || val === "" || val === "-";
      const aIsEmpty = isEmpty(aValue);
      const bIsEmpty = isEmpty(bValue);

      if (aIsEmpty && !bIsEmpty) return 1; // Move `a` to last
      if (!aIsEmpty && bIsEmpty) return -1; // Move `b` to last
      if (aIsEmpty && bIsEmpty) return 0; // Maintain order if both are empty

      // Handle date sorting
      if (field === "updated_at") {
        aValue = new Date(aValue);
        bValue = new Date(bValue);
      }

      // Handle number sorting
      if (typeof aValue === "number" && typeof bValue === "number") {
        return newSortOrder === "asc" ? aValue - bValue : bValue - aValue;
      }

      // Handle string sorting
      if (typeof aValue === "string" && typeof bValue === "string") {
        return newSortOrder === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      // Handle date sorting (fallback)
      if (aValue instanceof Date && bValue instanceof Date) {
        return newSortOrder === "asc" ? aValue - bValue : bValue - aValue;
      }

      return 0; // Default case
    });

    setData(sortedData);
  };
  const [openMSidebarDrawer, setOpenMSidebarDrawer] = React.useState("");
  const [isTabletLandscape, setIsTabletLandscape] = React.useState(false);

  React.useEffect(() => {
    const mediaQuery = window.matchMedia(
      "(min-width: 768px) and (max-width: 1024px) and (orientation: landscape)",
    );
    const handleChange = (e) => {
      setIsTabletLandscape(e.matches);
    };
    setIsTabletLandscape(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);
  return (
    <>
      {loading ? <Loader /> : null}
      <InfiniteScroll
        dataLength={decisionMakerData?.length || decisionMakerData?.length}
        next={() => fetchMoreData()}
        hasMore={hasMore}
        scrollableTarget="DecisionMaker-table-main"
      >
        {isPortrait ? (
          <>
            <div
              className="isMobile-isTabPortrait"
              style={{ padding: isMobile ? "0px" : "20px" }}
            >
              {data?.map((row, index) => (
                <Card
                  sx={{
                    borderRadius: 3,
                    boxShadow: 2,
                    background: selectedOuterRows?.some(
                      (item) => item?.person_id === row?.person_id,
                    )
                      ? "#c0dae6"
                      : "#fff",
                    mb: 2,
                  }}
                >
                  <CardContent>
                    {/* Header */}
                    <Grid container alignItems="center" spacing={1}>
                      <Grid item>
                        <div
                          className={
                            row?.decision_maker === true
                              ? "Decision-maker-user-name"
                              : "Decision-maker-user-noborder create-name-img"
                          }
                        >
                          <img
                            className={
                              row?.suspect_status === null
                                ? "hide-image"
                                : row?.journey_status === "project created"
                                  ? "decisionMakerImageAi-Decisionmaker-green"
                                  : "decisionMakerImageAi-Decisionmaker"
                            }
                            // src={decisionMakerImage}
                            src={
                              row?.journey_status === "project created"
                                ? activeSaleforceLogo
                                : decisionMakerImage
                            }
                            alt=""
                          />
                          <p className="letter-heading">
                            {row?.first_name
                              ? row?.first_name
                                  ?.split(" ")
                                  ?.find((item) => !item.includes("("))
                                  ?.charAt(0)
                              : ""}
                            {row?.last_name
                              ? row?.last_name
                                  ?.split(" ")
                                  ?.find((item) => !item.includes("("))
                                  ?.charAt(0)
                              : ""}
                          </p>
                        </div>
                      </Grid>
                      <Grid item xs>
                        <Typography
                          onClick={() => handleRowSelect(row)}
                          variant="subtitle1"
                          fontWeight="bold"
                          style={{ textTransform: "capitalize" }}
                        >
                          {row?.first_name === "jp"
                            ? "JP"
                            : row?.first_name || "-"}
                          &nbsp;
                          {row?.last_name ? row?.last_name : "-"}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          <div className="job-title-container">
                            <div className="tooltip-container-jobtitle">
                              <p
                                className={
                                  row?.raw_job_title
                                    ? "tooltip-highlights-jobtitle"
                                    : "tooltip-highlights-jobtitle-none"
                                }
                              >
                                {row?.raw_job_title}
                              </p>
                              <p className="after-company-name-country-fordecisionmaker">
                                {row?.primary_job_title
                                  ? row.primary_job_title.substring(0, 18) +
                                    (row.primary_job_title.length > 18
                                      ? "..."
                                      : "")
                                  : "-"}
                              </p>
                            </div>
                          </div>
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Box display="flex" alignItems="center" gap={1}>
                          {/* <StarBorderIcon fontSize="small" sx={{ color: "grey.600" }} /> */}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                              bgcolor: "#f5f6f8",
                              borderRadius: "50px",
                              px: 1.2,
                              py: 0.3,
                            }}
                          >
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              color="text.primary"
                            >
                              {row?.strengthData?.strength
                                ? row?.strengthData?.strength
                                : "-"}
                            </Typography>
                          </Box>
                          {row?.strengthData?.strength === 0 ||
                          row?.strengthData?.strength === "-" ? (
                            <IconButton
                              size="small"
                              sx={{
                                bgcolor: "hsl(220deg 4.04% 64.98%)",
                                "&:hover": {
                                  bgcolor: "hsl(220deg 4.04% 64.98%)",
                                },
                              }}
                            >
                              <ArrowForwardIosIcon
                                fontSize="small"
                                sx={{ color: "red" }}
                              />
                            </IconButton>
                          ) : (
                            <IconButton
                              size="small"
                              sx={{
                                bgcolor: "#f5f6f8",
                                "&:hover": { bgcolor: "#eaeaea" },
                              }}
                            >
                              <ArrowForwardIosIcon
                                fontSize="small"
                                sx={{ color: "red" }}
                                onClick={() => {
                                  setOpenMSidebarDrawer(row);
                                }}
                              />
                            </IconButton>
                          )}
                        </Box>
                      </Grid>
                    </Grid>

                    {/* Info Rows */}
                    <Box
                    // mt={2}
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={6}>
                          <Typography variant="caption" color="text.secondary">
                            Organization
                          </Typography>
                          <Typography variant="body2">
                            {row.primary_organization
                              ? row.primary_organization
                              : "-"}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="caption" color="text.secondary">
                            Industry
                          </Typography>
                          <Typography variant="body2">
                            {row?.categories}
                            {/* <IndustryDropdown row={row} /> */}
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          <Typography variant="caption" color="text.secondary">
                            JOSF Status
                          </Typography>
                          <Typography variant="body2">
                            {" "}
                            {row?.suspect_status ? row.suspect_status : "-"}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="caption" color="text.secondary">
                            Contact Details
                          </Typography>
                          {row?.linkedin ? (
                            <Typography
                              variant="body2"
                              style={{ display: "flex", gap: "5px" }}
                            >
                              {row?.linkedin.length > 28
                                ? row?.linkedin.substr(28, 22)
                                : row?.linkedin}
                              <span
                                onClick={() =>
                                  row?.linkedin && window?.open(row?.linkedin)
                                }
                              >
                                <img src={visitLinkImage} alt="" />
                              </span>
                            </Typography>
                          ) : (
                            ""
                          )}
                          {row?.email ? (
                            <Typography
                              variant="body2"
                              sx={{
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                              }}
                            >
                              {row?.email.length > 22
                                ? row?.email.substr(0, 22) + "..."
                                : row?.email}
                            </Typography>
                          ) : (
                            ""
                          )}
                          {row?.phone_no ? (
                            <Typography variant="body2">
                              {row?.phone_no.length > 22
                                ? row?.phone_no.substr(0, 22) + "..."
                                : row?.phone_no}
                            </Typography>
                          ) : (
                            ""
                          )}
                        </Grid>
                      </Grid>
                    </Box>
                  </CardContent>
                </Card>
              ))}
              <RightSidebarMobile
                isTabPortrait={isPortrait}
                openSidebar={openMSidebarDrawer}
                setOpenSidebar={setOpenMSidebarDrawer}
              />
              <div className="loadmore-pagination-section">
                {/* {totalCount !== decisionMakerData?.length && (
                  <button
                    className="btn-load-more button-loadmore-pagination"
                    onClick={loadMore}
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Load More"}
                  </button>
                )} */}
              </div>
            </div>
          </>
        ) : (
          <>
            {strengthTableData?.length ? (
              <TableContainer
                component={Paper}
                className={showCrieBoxes ? "" : "DecisionMaker-table-main"}
              >
                <Table
                  aria-label="collapsible table"
                  className="DecisionMaker-table"
                >
                  {showCrieBoxes ? (
                    <div className="table-row-ai-leads-cards">
                      <div className="titlescards-emp-table">
                        <p>
                          Name{" "}
                          {sortField === "first_name" ? (
                            sortOrder === "asc" ? (
                              <NorthIcon
                                className="up-down-arrows-sorting"
                                onClick={() => handleSort("first_name")}
                              />
                            ) : (
                              <SouthIcon
                                className="up-down-arrows-sorting"
                                onClick={() => handleSort("first_name")}
                              />
                            )
                          ) : (
                            <img
                              src={sortingimg}
                              alt=""
                              onClick={() => handleSort("first_name")}
                              className="sorting-arrow-leadsprofile"
                              style={{ cursor: "pointer" }}
                            />
                          )}
                        </p>
                        <p>
                          JOI Strength{" "}
                          {sortField === "strengthData.strength" ? (
                            sortOrder === "asc" ? (
                              <NorthIcon
                                className="up-down-arrows-sorting"
                                onClick={() =>
                                  handleSort("strengthData.strength")
                                }
                              />
                            ) : (
                              <SouthIcon
                                className="up-down-arrows-sorting"
                                onClick={() =>
                                  handleSort("strengthData.strength")
                                }
                              />
                            )
                          ) : (
                            <img
                              src={sortingimg}
                              alt=""
                              onClick={() =>
                                handleSort("strengthData.strength")
                              }
                              className="sorting-arrow-leadsprofile"
                              style={{ cursor: "pointer" }}
                            />
                          )}
                        </p>

                        <p>
                          JOSF Status{" "}
                          {sortField === "suspect_status" ? (
                            sortOrder === "asc" ? (
                              <NorthIcon
                                className="up-down-arrows-sorting"
                                onClick={() => handleSort("suspect_status")}
                              />
                            ) : (
                              <SouthIcon
                                className="up-down-arrows-sorting"
                                onClick={() => handleSort("suspect_status")}
                              />
                            )
                          ) : (
                            <img
                              src={sortingimg}
                              alt=""
                              onClick={() => handleSort("suspect_status")}
                              className="sorting-arrow-leadsprofile"
                              style={{ cursor: "pointer" }}
                            />
                          )}
                        </p>
                      </div>
                      <div>
                        <p>
                          <img
                            style={{ cursor: "pointer" }}
                            src={crieboxestwo}
                            alt=""
                            onClick={handleCrieBoxesClose}
                          />
                        </p>
                      </div>
                    </div>
                  ) : (
                    <TableHead>
                      <TableRow className="table-row-ai-leads">
                        <TableCell className="checkbox-row-table-inner checkbox-row-table">
                          <div className="kjhgf">
                            <input
                              type="checkbox"
                              onChange={(e) =>
                                setRowsSelectAll(e?.target?.checked)
                              }
                              checked={rowsSelectAll}
                            />
                          </div>
                        </TableCell>{" "}
                        <TableCell className="Decisions-row-empty"></TableCell>
                        <TableCell className="Decisions-row-tableNameaAndtitle">
                          <p className="title-of-company-profile-screen">
                            Name & Title{" "}
                            {sortField === "first_name" ? (
                              sortOrder === "asc" ? (
                                <NorthIcon
                                  className="up-down-arrows-sorting"
                                  onClick={() => handleSort("first_name")}
                                />
                              ) : (
                                <SouthIcon
                                  className="up-down-arrows-sorting"
                                  onClick={() => handleSort("first_name")}
                                />
                              )
                            ) : (
                              <img
                                src={sortingimg}
                                alt=""
                                onClick={() => handleSort("first_name")}
                                className="sorting-arrow-leadsprofile"
                                style={{ cursor: "pointer" }}
                              />
                            )}
                          </p>
                        </TableCell>
                        <TableCell
                          align="left"
                          className="DecisionstableJOIStrength"
                        >
                          <p
                            className="strengthdata"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            JOI Strength{" "}
                            {sortField === "strengthData.strength" ? (
                              sortOrder === "asc" ? (
                                <NorthIcon
                                  className="up-down-arrows-sorting"
                                  onClick={() =>
                                    handleSort("strengthData.strength")
                                  }
                                />
                              ) : (
                                <SouthIcon
                                  className="up-down-arrows-sorting"
                                  onClick={() =>
                                    handleSort("strengthData.strength")
                                  }
                                />
                              )
                            ) : (
                              <img
                                src={sortingimg}
                                alt=""
                                onClick={() =>
                                  handleSort("strengthData.strength")
                                }
                                className="sorting-arrow-leadsprofile"
                                style={{ cursor: "pointer" }}
                              />
                            )}
                          </p>
                        </TableCell>
                        <TableCell
                          align="left"
                          className="annual-row-tableIndustrySector"
                        >
                          <p className="sector-heading-companyscreen">
                            Industry/ Sector{" "}
                            {sortField === "categories" ? (
                              sortOrder === "asc" ? (
                                <NorthIcon
                                  className="up-down-arrows-sorting"
                                  onClick={() => handleSort("categories")}
                                />
                              ) : (
                                <SouthIcon
                                  className="up-down-arrows-sorting"
                                  onClick={() => handleSort("categories")}
                                />
                              )
                            ) : (
                              <img
                                src={sortingimg}
                                alt=""
                                onClick={() => handleSort("categories")}
                                className="sorting-arrow-leadsprofile"
                                style={{ cursor: "pointer" }}
                              />
                            )}
                          </p>
                        </TableCell>
                        {isTabletLandscape ? (
                          ""
                        ) : (
                          <TableCell
                            align="left"
                            className="industry-row-tableStatus"
                          >
                            <p
                              className="strengthdata"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                              }}
                            >
                              JOSF Status{" "}
                              {sortField === "suspect_status" ? (
                                sortOrder === "asc" ? (
                                  <NorthIcon
                                    className="up-down-arrows-sorting"
                                    onClick={() => handleSort("suspect_status")}
                                  />
                                ) : (
                                  <SouthIcon
                                    className="up-down-arrows-sorting"
                                    onClick={() => handleSort("suspect_status")}
                                  />
                                )
                              ) : (
                                <img
                                  src={sortingimg}
                                  alt=""
                                  onClick={() => handleSort("suspect_status")}
                                  className="sorting-arrow-leadsprofile"
                                  style={{ cursor: "pointer" }}
                                />
                              )}
                            </p>
                          </TableCell>
                        )}
                        <TableCell
                          align="left"
                          className="prospects-row-tableDetails-cd"
                        >
                          <p className="Com-details-prospect">
                            {" "}
                            Contact Details
                          </p>
                        </TableCell>
                        <TableCell
                          align="left"
                          className="prospects-row-tableDetails-cd"
                        >
                          <p className="Com-details-prospect-criecards">
                            {" "}
                            <img
                              src={crieboxes}
                              alt=""
                              onClick={handleCrieBoxes}
                            />{" "}
                          </p>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                  )}
                  <TableBody
                    className={showCrieBoxes ? "crieboxes-emptable" : ""}
                  >
                    {data?.map((row, index) => (
                      <React.Fragment key={index}>
                        <Row
                          row={row}
                          selected={selectedRows.includes(row.first_name)}
                          onSelect={(firstName) => {
                            const selectedIndex =
                              selectedRows.indexOf(firstName);
                            let newSelected = [];
                            if (selectedIndex === -1) {
                              newSelected = newSelected.concat(
                                selectedRows,
                                firstName,
                              );
                            } else if (selectedIndex === 0) {
                              newSelected = newSelected.concat(
                                selectedRows.slice(1),
                              );
                            } else if (
                              selectedIndex ===
                              selectedRows.length - 1
                            ) {
                              newSelected = newSelected.concat(
                                selectedRows.slice(0, -1),
                              );
                            } else if (selectedIndex > 0) {
                              newSelected = newSelected.concat(
                                selectedRows.slice(0, selectedIndex),
                                selectedRows.slice(selectedIndex + 1),
                              );
                            }
                            setSelectedRows(newSelected);
                          }}
                          setRowsSelect={setRowsSelect}
                          selectedOuterRows={selectedOuterRows}
                          favoritesList={favoritesList}
                          setFavoritesList={setFavoritesList}
                          listFavoriteRecords={listFavoriteRecords}
                          handleRowSelect={handleRowSelect}
                          showCrieBoxes={showCrieBoxes}
                          setValue={setValue}
                          setCrieNavigate={setCrieNavigate}
                          aiDecisionMakerTableCompany={
                            aiDecisionMakerTableCompany
                          }
                          isTabletLandscape={isTabletLandscape}
                        />
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <div className="ai-leads-table-main">
                <div className="ai-leads-no-data-available-outter">
                  <div className="ai-leads-no-data-available">
                    No Data Available
                  </div>
                </div>
              </div>
            )}{" "}
          </>
        )}
      </InfiniteScroll>
      <MessageModal
        open={messageModal}
        setOpen={setMessageModal}
        handleSubmit={handleArchiveRecords}
        message={`Are you sure that you want to archive ${
          selectedOuterRows?.length > 1 ? "these records" : "this record"
        }?`}
        length={selectedOuterRows?.length}
      />
      <MessageModal
        open={messageModalTrack}
        setOpen={setMessageModalTrack}
        message={`Are you sure that you want to add ${
          selectedOuterRows?.length > 1 ? "these records" : "this record"
        } to tracking?`}
        handleSubmit={handleTrackRecords}
        length={selectedOuterRows?.length}
      />

      <SalesForceMessageModal
        open={messageModalSalesforce}
        setOpen={setMessageModalSalesforce}
        selectedOuterRows={selectedOuterRows}
        setSelectedOuterRows={setSelectedOuterRows}
        setIsSalesForceTrigger={setIsSalesForceTrigger}
        decisionMakerData={decisionMakerData}
        setLoading={setLoading}
      />

      <ProspectRequestModal
        requestUpdateRecord={requestUpdateModal}
        setRequestUpdateRecord={setRequestUpdateModal}
        profileData={selectedOuterRows?.[0]}
        peopleId={selectedOuterRows?.[0]?.id}
        setSelectedOuterRows={setSelectedOuterRows}
        setSuccessModel={setSuccessModel}
        successModel={successModel}
      />
      {selectedOuterRows?.length ? (
        <PeopleDetailsFav
          profileData={selectedOuterRows?.map((i) => i?.person_id)}
          fetchdata={() => aiDecisionMakerTableCompany(true)}
          open={openCreateListmdl}
          setSelectedOuterRows={setSelectedOuterRows}
          setOpen={setOpenCreateListmdl}
          message={`Are you sure that you want to add ${
            selectedOuterRows?.length > 1 ? "these records" : "this record"
          } to Favorites?`}
        />
      ) : (
        <OrgDetailsFav
          informationData={informationData}
          open={openCreateListmdl}
          setOpen={setOpenCreateListmdl}
          dataForInformation={dataForInformation}
          informationDataModal={informationDataModal}
          message={`Are you sure that you want to add ${
            selectedOuterRows?.length > 1 ? "these records" : "this record"
          } to Favorites?`}
        />
      )}
      <Modal
        open={successModel == true}
        onClose={() => setSuccessModel(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="vrufyerv">
          <Box sx={style} style={{ overflowY: "auto", width: "30%" }}>
            <div className="de_pad_req-up">
              <p className="cross-people-req-model">
                <ClearIcon onClick={() => setSuccessModel(false)} />
              </p>
              <p className="de_head">
                Your Record Update request has been successfully submitted. The
                JOI team will review your request and notify you when the record
                has been updated.
              </p>
            </div>
          </Box>
        </div>
      </Modal>
    </>
  );
}
